/* global IMask */

/**
 * Applies a Brazilian phone number input mask to every element with the `.tel-mask` class.
 * @returns {void}
 */
function initTelMask() {
    document.querySelectorAll('.tel-mask').forEach(e => {
        new IMask(e, {
            mask: [
                { mask: '(00) 0000-0000' },
                { mask: '(00) 0 0000-0000' }
            ]
        });
    });
}

initTelMask();

function initCpfMask() {
    document.querySelectorAll('.cpf-mask').forEach(e => {
        new IMask(e, {
            mask: '000.000.000-00'
        });
    });
}

initCpfMask();

/**
 * Syncs each custom select box's visible label with the underlying native `<select>`'s
 * selected option text whenever it changes.
 * @returns {void}
 */
function initCustomSelect() {
    document.querySelectorAll('.select-custom-box select').forEach(e => {
        let label = e.getAttribute('data-select-target');
        if (label[0] !== '#') {
            label = `#${label}`;
        }
        e.addEventListener('change', () => {
            document.querySelector(`${label} span`).textContent = e.options[e.selectedIndex].text;
        });
    });
}

initCustomSelect();

/**
 * Displays the selected file name(s) next to every custom file input (`.attachment`).
 * @returns {void}
 */
function initCustomFileInput() {
    document.querySelectorAll('.attachment').forEach(a => {
        const input = a.querySelector('input[type="file"');

        input.addEventListener('change', inp => {
            const label = a.querySelector('.text');
            let fileName = '';

            if(inp.target.files && inp.target.files.length > 1) {
                fileName = (inp.target.getAttribute('data-multiple-caption') || '').replace('{count}', inp.target.files.length);
            } else if(inp.target.value) {
                fileName = inp.target.value.split('\\').pop();
            }
            label.querySelector('span').innerHTML = fileName;
        });
    });
}

initCustomFileInput();

/**
 * Disables each form's submit button and shows a loading label once it's actually about to
 * submit, so a slow request can't be triggered twice. Applies to every form on the page,
 * current or future - no per-form wiring needed.
 *
 * Listens for Bouncer's `bouncerFormValid` event on forms with `[data-validate]`, instead of
 * the native `submit` event: Bouncer's own submit handler lives on `document` and runs AFTER
 * a listener attached directly to the form, so a `submit`-based guard would disable the button
 * on invalid attempts too - and since Bouncer then blocks the actual submission, the button
 * would never get re-enabled (dead button after the first failed attempt). `bouncerFormValid`
 * only fires once validation actually passed and the form is really about to submit.
 * @returns {void}
 */
function initFormSubmitLoadingState() {
    document.querySelectorAll('form').forEach(form => {
        const button = form.querySelector('button[type="submit"]');
        if (button === null) {
            return;
        }

        const loadingEvent = form.hasAttribute('data-validate') ? 'bouncerFormValid' : 'submit';
        form.addEventListener(loadingEvent, () => {
            button.setAttribute('disabled', 'disabled');
            button.textContent = 'Enviando, aguarde...';
        });
    });
}

initFormSubmitLoadingState();

/**
 * Toggles a password input between masked and visible text.
 * @param {HTMLInputElement} e The checkbox element that toggled visibility; its previous
 * sibling is the password input to toggle.
 * @returns {void}
 */
// eslint-disable-next-line
function switchPasswordVisibility(e) {
    let x = e.previousElementSibling;
    x.type = x.type === 'password' ? 'text' : 'password';
}
